import { ReactNode, useCallback, useContext, useState } from 'react';
import { useTheme } from 'styled-components';
import { useTranslation } from 'react-i18next';
import { Flex, Devider, Text, Button, ViewerContext, Box } from 'dash-ui';

interface IProps {
  title: string;
  subtitle: string;
  isEmail?: boolean;
  children?: (close: () => void) => ReactNode;
}

function SettingsSection({ title, subtitle, children, isEmail }: IProps) {
  const [isOpen, setIsOpen] = useState(false);
  const theme = useTheme();
  const { t } = useTranslation(['common']);
  const { account } = useContext(ViewerContext);

  const close = useCallback(() => setIsOpen(false), [setIsOpen]);

  return (
    <Flex mt={4} w="100%" flexDirection="column">
      <Flex
        w="100%"
        flexDirection="row"
        alignItems="center"
        justifyContent="space-between"
      >
        <Flex>
          <Text semibold>{title}</Text>
        </Flex>
        <Flex>
          <Button h={24} variation="flat" onClick={() => setIsOpen(!isOpen)}>
            {isOpen ? t('common:labels:close') : t('common:labels:change')}
          </Button>
        </Flex>
      </Flex>
      <Flex mt={0.5}>
        <Text color={theme.colors.n70}>{subtitle}</Text>
      </Flex>
      {isEmail && account && (
        <Flex mt={0.5} alignItems="center">
          <Box mr={1.5}>
            <Text color={theme.colors.n70}>
              {t('pages:profilePage:settings:yourEmail')}:
            </Text>
          </Box>
          <Text color={theme.colors.b50}>{account.email}</Text>
        </Flex>
      )}
      {isOpen && <Flex w="100%">{children && children(close)}</Flex>}
      <Devider w="100%" mt={4} />
    </Flex>
  );
}

export default SettingsSection;
